import { useRef } from 'react';
import Popover, { type IPopoverRef } from '@dealroadshow/uikit-popover';
import IconArrowDown from '@creditflowresearch/uilib/Icon/IconArrowDown';
import TruncateText from '@creditflowresearch/uilib/TruncateText';
import { useAskAiChatListContext } from '@/creditflowresearch/application/AskAiChat/context/AskAiChatContext';
import { useAiSidebarContext } from '@/creditflowresearch/application/AiSidebar/AiSidebarContext';
import ChatHistoryList from './ChatHistory/ChatHistoryList';
import styles from './chatTitleMenu.module.scss';

const ChatTitleMenu = () => {
  const { chats, chatId } = useAskAiChatListContext();
  const { isSplit, isFullScreen } = useAiSidebarContext();

  const popoverRef = useRef<IPopoverRef>(null);

  const currentTitle = chats.find((chat) => chat.id === chatId)?.title ?? 'New chat';

  if (isSplit && isFullScreen) {
    return (
      <span className={ styles.title } data-test="askAiChatTitle">
        <TruncateText value={ currentTitle } />
      </span>
    );
  }

  return (
    <Popover
      ref={ popoverRef }
      content={ (
        <ChatHistoryList
          className={ styles.menu }
          onOpen={ () => popoverRef.current?.hide() }
          dataTest="askAiChatHistoryMenu"
        />
      ) }
      contentClassName={ styles.popoverContent }
      placement="bottom-start"
      dataTest="askAiChatHistoryPopover"
      closeOnClickOutside
    >
      <button
        type="button"
        className={ styles.trigger }
        data-test="askAiChatTitleButton"
      >
        <span className={ styles.triggerTitle }>
          <TruncateText value={ currentTitle } />
        </span>
        <IconArrowDown size={ 12 } />
      </button>
    </Popover>
  );
};

export default ChatTitleMenu;
